<template>
  <v-app-bar
    app
    flat
    height="72"
    class="menu-bar px-10"
  >
    <!-- LOGO -->
    <div class="logo-area" @click="$router.push({ name: 'site' })" style="cursor: pointer;">
      <div class="logo-icon">
        <img src="@/assets/logoSemFundo.png" alt="Logo" width="52" height="40" />
      </div>
      <div class="brand-text">
        <h1 class="brand-title">Cargas<span style="color:#16b37c">Zap</span></h1>
      </div>
    </div>

    <v-spacer />

    <!-- MENU CENTRAL -->
    <div class="menu-center">
      <v-btn class="menu-link" text @click="$router.push({ name: 'sobre' })">Sobre nós</v-btn>
      <v-btn class="menu-link" text @click="redirecionarSecao('secao solucao')">Funcionalidades</v-btn>
      <v-btn class="menu-link" text @click="redirecionarSecao('Diferencial')">Diferencial</v-btn>
      <v-btn class="menu-link" outlined color="primary" @click="$router.push({ name: 'login' })">Área do Cliente</v-btn>
    </div>

    <v-spacer />

    <!-- LADO DIREITO -->
    <div class="right-area">
      <v-btn text class="menu-link whatsapp-link">
        Duvidas?
      </v-btn>

      <v-btn class="demo-btn" elevation="0" to="/cadastro">
        Testar Gratis
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
export default {
  name: "MenuBar",

  methods: {
    redirecionarSecao(secao) {
      const id = secao.toLowerCase().replace(/\s+/g, '-');

      if (this.$route.name !== 'site') {
        sessionStorage.setItem('scrollTarget', id);
        this.$router.push({ name: 'site' });
      } else {
        this.$nextTick(() => {
          const elemento = document.getElementById(id);
          if (elemento) elemento.scrollIntoView({ behavior: 'smooth' });
        });
      }
    }
  },

  watch: {
    $route(to) {
      if (to.name === 'site') {
        const target = sessionStorage.getItem('scrollTarget');
        if (target) {
          sessionStorage.removeItem('scrollTarget');
          setTimeout(() => {
            const elemento = document.getElementById(target);
            if (elemento) elemento.scrollIntoView({ behavior: 'smooth' });
          }, 500);
        }
      }
    }
  }
};
</script>

<style scoped>
.menu-bar {
  background: linear-gradient(
    90deg,
    #0d1b2a 0%,
    #0f2235 50%,
    #0d1b2a 100%
  );
  font-family: "Inter", sans-serif;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

/* LOGO */
.logo-area {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 260px;
}

.logo-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.brand-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
}

.brand-subtitle {
  color: #22c58b;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
}

/* MENU CENTRAL */
.menu-center {
  display: flex;
  align-items: center;
  gap: 28px;
}

.menu-link {
  color: #cfd8e3 !important;
  font-size: 15px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.01em;
}

.menu-link:hover {
  color: #ffffff !important;
}

/* DIREITA */
.right-area {
  display: flex;
  align-items: center;
  gap: 24px;
}

.whatsapp-link {
  color: #ffffff !important;
  font-weight: 500;
}

/* BOTÃO VERDE */
.demo-btn {
  background: #22c58b !important;
  color: white !important;
  font-weight: 600;
  font-size: 15px;
  text-transform: none;
  padding: 0 22px;
  height: 44px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.demo-btn:hover {
  background: #1eb37d !important;
}
</style>